import { render, staticRenderFns } from "./ExternalList.vue?vue&type=template&id=2475be42"
import script from "./ExternalList.vue?vue&type=script&lang=js"
export * from "./ExternalList.vue?vue&type=script&lang=js"
import style0 from "./ExternalList.vue?vue&type=style&index=0&id=2475be42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports